<template>
  <div>
    <va-modal v-model="showModal"
              id="createLogoModal"
              ref="createLogoModal"
              :cancelText="$t('leads.back')"
              size="large"
              :showOkay="true"
              :okText="this.$t('iframe.logos-library.create')"
              @cancel="$emit('cancel')"
              @ok="handleSubmit"
              :ok-disabled="!canSubmit"
              :noOutsideDismiss="true">

      <div slot="header" class="d-flex justify--space-between">
        <span>
            <span><b style="font-size:22px; margin-bottom: 1rem;" class="mr-2"> {{ this.$t('iframe.logos-library.create')}}</b></span>
          </span>
      </div>
      <LogoDetail
        v-model="logoForm"
        :formErrors="logoErrors"
        :collapsable="true"
        :clientOptions="clientOptions"
      />

    </va-modal>
  </div>

</template>

<script>
import {IframeService} from "@/api/IframeService";
import LogoDetail from '@/components/iframe/logo-library/LogoDetail.vue';
import Errors from "@/utils/StandardErrors";
import Multiselect from "vue-multiselect";
const errorsPrefix = 'iframe.logos-library.errors.'
export default {
  components: { Multiselect, LogoDetail },
  data() {
    return {
      showModal: false,
      isLoading: true,
      logoForm: {
        client: null,
        logo: null,
        name: null,
      },
      logoErrors: new Errors(),
      logo: null,
    }
  },
  mounted() {
    this.showModal = true
  },
  methods: {
    handleSubmit: function() {
      if (this.canSubmit) {
        this.isSubmiting = true
        const formDataToSubmit = {...this.logoForm}

        const formData = new FormData()
        Object.entries(formDataToSubmit).forEach(([key, val]) => {
          if(key === "client") {
            formData.append("clientId", val.id.toString())
          } else {
            formData.append(key, val)
          }

        })



        IframeService.createLogo(formData,  (formData.logo !== null ))
          .then(res => {
            this.showToast(this.$t('iframe.logos-library.created_success'), this.$store.state.successToastOptions)
            this.$emit('created')
            this.showModal = false
          })
          .catch(errors => {
            console.log(errors)
            if(errors.response.status === 422) {
              this.logoErrors.record(errors.response.data.errors, errorsPrefix)
            }
            this.showToast(this.$t('iframe.logos-library.created_error'), this.$store.state.errorToastOptions)
          })
          .finally(() => { this.isSubmiting = false } )
      }
    }
  },
  computed: {
    canSubmit() {
      return (this.logoForm.name !== null && this.logoForm.name !== '') && !this.isSubmiting && this.logoForm.logo !== null && this.logoForm.client !== null
    },
    iframeService: function () {
      return this.$store.state.services.find(service => service.slug === 'iframe') || null
    },
    clientOptions: function () {
      //let iframeService = this.$store.state.services.find(service => service.url === this.$store.state.iframe_server) || null
      if (this.iframeService) {
        if (this.iframeService.user_permissions.some(perm => perm.entity_id === null)) {
          if(this.iframeService.entities.length === 1) {
            this.logoForm.client = this.iframeService.entities[0]
          }
          return this.iframeService.entities
        }
        const consideredEntitiesIds = this.iframeService.user_permissions.filter(perm => perm.access_type >= 1 && perm.info_type === 120).map(elem => elem.entity_id)
        const consideredEntities = this.iframeService.entities.filter(entity =>  consideredEntitiesIds.includes(entity.id))
        if (consideredEntities.length === 1) {
          this.logoForm.client = consideredEntities[0]
        }
        return consideredEntities
      }
      return []
    },
  }
}
</script>

<style scoped>

</style>
